import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ProtectionClub')
export class ProtectionClub {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('address', String, true)
    address = null;

    @JsonProperty('city', String, true)
    city = null;

    @JsonProperty('country', String, true)
    country = null;

    @JsonProperty('phone_1', String, true)
    phone1 = null;

    @JsonProperty('phone_2', String, true)
    phone2 = null;

    @JsonProperty('direct_phone', String, true)
    directPhone = null;

    @JsonProperty('fax', String, true)
    fax = null;

    @JsonProperty('email', String, true)
    email = null;

    @JsonProperty('operator', String, true)
    operator = null;

    @JsonProperty('contact_name', String, true)
    contactName = null;

    @JsonProperty('contact_phone', String, true)
    contactPhone = null;

    @JsonProperty('contact_email', String, true)
    contactEmail = null;

    @JsonProperty('created_date', String, true)
    createdDate = null;

    @JsonProperty('updated_date', String, true)
    updatedDate = null;


    public get location(): string {
        let l = "";
        l = this.address ? this.address + ", " : "";
        l += this.city ? this.city + ", " : "";
        l += this.country ? this.country : "";

        return (this.address || this.city || this.country) ? l : '—';
    }
}